import { Component, effect, inject, signal } from '@angular/core';
import { LoadingIcon } from '../loading/loading.component';
import { GlobalService } from 'app/shared/services/global.service';
import { fuseAnimations } from '@fuse/animations';

@Component({
    selector: 'modal-overlay',
    templateUrl: './modal-overlay.component.html',
    styleUrls: ['./modal-overlay.component.scss'],
    animations: fuseAnimations,
    imports: [ LoadingIcon ],
})
export class ModalOverlayComponent
{
    private _globalService = inject(GlobalService);

    visible = signal(false);
    text: string = 'Please wait';

    constructor() {
        effect(() => {
            const modalData = this._globalService.modal();
            this.visible.set(modalData != null);
            this.text = modalData?.text ?? 'Please wait';
        });
    }

}
